import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import SettingsPanel from "./settingsPanel";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services/common.service";
// core components
import moment from "moment";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Table from "components/Table/Table.jsx";
import { connect } from "react-redux";
import Tabs from "components/CustomTabs/CustomTabs.jsx";
import Seat from "@material-ui/icons/AirlineSeatFlat";
import Airline from "@material-ui/icons/AirlineSeatReclineNormal";
import ApprovedTable from "./approvedTable";
import AllPscTable from "./allCharges";
import { appConstants } from "../../_constants";
import CircularProgress from "../../utils/CircularProgress";
import { Grid, TextField } from "@material-ui/core";
import { store } from "../../_store";

const presentDate = new Date();
const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

const styles = (theme) => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  negativeColor: {
    color: "red",
  },
  positiveColor: {
    color: "green",
  },
  nb: {
    color: "red",
    fontSize: "12px",
  },
  wide: {
    width: "100%",
    minWidth: "300px",
  },
});

class PscSettingsTable extends React.Component {
  state = {
    page: 0,
    response: "",
    rowsPerPage: 10,
    open: false,
    openApprove: false,
    airlineName: "",
    airlineId: "",
    PscChargePendingId: "",
    pendingRecord: "",
    recordCreatedBy: "",
    newRecordCharge: "",
    oldRecordCharge: "",
    ApprovedBy: "",
    ExchangeData: [],
    pendingExchangeData: [],
    openModal: false,
    currentExchange: 0,
    errorMessage: "",
    errorComponent: false,
    editErrorComponent: false,
    users: [],
    currentPage: 1,
    currentPagePending: 1,
    TotalCount: 0,
    totalCountPending: 0,
    totalCountApprove: 0,
    error: false,
    formError: "",
    requestingFlights: true,
    reason: "",
    comment: "",
    Status: 0,
    openComment: false,
    approveExchangeRateId: "",
    rejectExchangeRateId: "",
    pageSize: 10,
    date: new Date(),
    startDate: moment(firstDay, "YYYY-MM-DD"), //first day of the current month
    endDate: moment(presentDate, "YYYY-MM-DD"), //End date by default will always be current date
    DateType: 0,
    invoiceNumber: "",
    createdBy: "",
    notCreatedBy: "",
    approvedBy: "",
    newExchangeRate: 0,
    isApprove: false,
    isReject: false,
    currentExchangeRate: [],
  };

  componentDidMount() {
    let { users } = store.getState();
    const { dispatch } = this.props;
    if (users) {
      this.setState({ users: users.ResultList });
    } else {
      dispatch(commonActions.getAllUsers());
    }
    this.searchExchangeRatePending();
    this.searchExchangeRateApproved();
    this.getCurrentExchangeRate();
  }

  componentWillReceiveProps = function(nextProps) {
    const { users } = nextProps;
    if (users) {
      this.setState({ users: users.ResultList });
    }
  };

  //Get Exchange Rate
  getCurrentExchangeRate = (pageNumber = 0) => {
    const { dispatch } = this.props;
    const { pageSize, startDate, endDate } = this.state;
    let payload = {
      pageSize: pageSize,
      From: pageNumber === 1 || pageNumber === 0 ? 0 : pageNumber - 1,
      Parameter: {
        StartDate: moment(startDate).format("YYYY-MM-DD"),
        EndDate: moment(endDate).format("YYYY-MM-DD"),
      },
    };

    dispatch(alertActions.startRequest());
    commonService.searchExchangeRateRegional(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let results = response.Results;
        this.setState({
          totalCount: response.TotalCount,
          currentExchangeRate: results,
          // currentExchange: results[0] ? results[0].Rate : 0,
          currentExchange: response.ExchangeRateToday,
          currentPage: pageNumber === 0 ? 1 : pageNumber,
        });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  //Get All Pending Exchange Rate
  searchExchangeRatePending = (pageNumber = 0) => {
    const { dispatch } = this.props;
    const {
      pageSize,
      startDate,
      endDate,
      approvedBy,
      createdBy,
      invoiceNumber,
      notCreatedBy,
    } = this.state;
    
    let payload = {
      pageSize: pageSize,
      From: pageNumber === 0 ? 0 : (pageNumber - 1) * pageSize,
      Parameter: {
        StartDate: moment(startDate).format("YYYY-MM-DD"),
        EndDate: moment(endDate).format("YYYY-MM-DD"),
        DateType: 0,
        InvoiceNumber: invoiceNumber,
        Status: 0,
        CreatedBy: createdBy,
        NotCreatedBy: notCreatedBy,
        ApprovedBy: approvedBy,
      },
    };
    dispatch(alertActions.startRequest());
    commonService.searchExchangeRatePendingRegional(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let results = response.Results;
        this.setState({
          totalCountPending: response.TotalCount,
          pendingExchangeData: results,
          currentPagePending: pageNumber === 0 ? 1 : pageNumber,
        });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  //Get All Approved Exchange Rate
  searchExchangeRateApproved = (pageNumber = 0) => {
    const { dispatch } = this.props;
    const {
      pageSize,
      startDate,
      endDate,
      approvedBy,
      createdBy,
      invoiceNumber,
      notCreatedBy,
    } = this.state;
    let payload = {
      pageSize: pageSize,
      From: pageNumber === 0 ? 0 : (pageNumber - 1) * pageSize,
      Parameter: {
        StartDate: moment(startDate).format("YYYY-MM-DD"),
        EndDate: moment(endDate).format("YYYY-MM-DD"),
        DateType: 0,
        InvoiceNumber: invoiceNumber,
        Status: 1,
        CreatedBy: createdBy,
        NotCreatedBy: notCreatedBy,
        ApprovedBy: approvedBy,
      },
    };
    dispatch(alertActions.startRequest());
    commonService.searchExchangeRatePendingRegional(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let results = response.Results;
        this.setState({
          totalCountApprove: response.TotalCount,
          ExchangeData: results,
          currentPage: pageNumber === 0 ? 1 : pageNumber,
        });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  //Save New Exchange Rate value Button
  handleExchangeSave = () => {
    const { newExchangeRate, date } = this.state;
    const { user, dispatch } = this.props;
    let payload = {
      EffectiveDate: moment(date).format("YYYY-MM-DD"),
      Rate: newExchangeRate,
      CreatedBy: user.userId,
    };
    dispatch(alertActions.startRequest());
    commonService
      .saveExchangeRatePendingRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ formError: res.response, error: true });
        } else if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.notify("Saved Successfully"));
          this.searchExchangeRateApproved();
          this.searchExchangeRatePending();
          this.getCurrentExchangeRate();
          this.setState({ openModal: false, editErrorComponent: false });
        }
      })
      .catch((err) => {
        dispatch(alertActions.stopRequest());
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  //Handle Input
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  //Open Set New PSC Modal
  handleExchangeRate = () => {
    this.setState({ openModal: true });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      openApprove: false,
      open: false,
      openComment: false,
    });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleSelectChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  //Approve Exchange Rate
  handleApprove = (status, id) => {
    this.setState({
      approveExchangeRateId: id,
      status: status,
      openComment: true,
      isApprove: true,
    });
  };

  //Reject Exchange Rate
  handleReject = (status, id) => {
    this.setState({
      rejectExchangeRateId: id,
      status: status,
      openComment: true,
      isReject: true,
    });
  };
  //approve exchange rate and it modal
  approveExchangeRate = () => {
    const { user, dispatch } = this.props;
    const { approveExchangeRateId } = this.state;
    let payload = {
      ExchangeRatePendingId: approveExchangeRateId,
      UserId: user.userId,
    };
    dispatch(alertActions.startRequest());
    commonService.approveExchangeRatePendingRegional(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        dispatch(alertActions.notify("Exchange Rate Approved Successfully"));
        this.searchExchangeRatePending();
        this.searchExchangeRateApproved();
        this.getCurrentExchangeRate();
        this.setState({ openApprove: false, openComment: false, comment: "" });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        this.setState({ errorMessage: res.response });
      }
    });
    dispatch(alertActions.clear());
  };

  rejectExchangeRate = () => {
    const { user, dispatch } = this.props;
    const { rejectExchangeRateId } = this.state;
    let payload = {
      ExchangeRatePendingId: rejectExchangeRateId,
      UserId: user.userId,
    };
    dispatch(alertActions.startRequest());
    commonService
      .rejectExchangeRatePendingRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.notify("Exchange Rate Rejected Successfully"));
          this.searchExchangeRatePending();
          this.searchExchangeRateApproved();
          this.getCurrentExchangeRate();
          this.setState({
            openApprove: false,
            openComment: false,
            comment: "",
          });
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ errorMessage: res.response });
        }
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response));
      });
    dispatch(alertActions.clear());
  };

  filterUsers = (userId) => {
    const { users } = this.state;
    if (users) {
      let userName = users.find((u) => u.Id === userId);
      if (userName) {
        return `${userName.FirstName} ${userName.LastName}`;
      } else {
        return "Unknown User"; //`Unknown User`;
      }
    }

  };

  handleDateChange = (date, target) => {
    this.setState({ [target]: date });
  };

  selectedTab = (key) => {
    // this.setState({currentTab: key})
  };
  render() {
    const { fullScreen, requesting } = this.props;
    const {
      pageRequesting,
      airlines,
      name,
      newExchangeRate,
      formError,
      currentPagePending,
      currentPage,
      startDate,
      endDate,
      error,
      pageSize,
      pendingExchangeData,
      errorComponent,
      errorMessage,
      currentExchange,
      openModal,
      ExchangeData,
      reason,
      comment,
      isReject,
      isApprove,
      date,
    } = this.state;

    if (pageRequesting) return <CircularProgress />;
    return (
      <GridContainer>
        <SettingsPanel
          errorComponent={errorComponent}
          formError={formError}
          error={error}
          errorMessage={errorMessage}
          openModal={openModal}
          handleChange={(event) => this.handleChange(event)}
          handleExchangeRate={this.handleExchangeRate}
          currentExchange={currentExchange}
          airlines={airlines}
          airline={name}
          selectChange={this.handleSelectChange("airlines")}
          handleClose={this.handleClose}
          handleExchangeSave={this.handleExchangeSave}
          disabled={requesting}
          newExchangeRate={newExchangeRate}
          date={date}
          dateLabel={"Date"}
          startDate={startDate}
          endDate={endDate}
          startLabel="Start Date"
          endLabel="End Date"
          handleDateChange={this.handleDateChange.bind(this)}
          handleSearchPending={this.searchExchangeRatePending}
          handleSearchApprove={this.searchExchangeRateApproved}
        />
        <Tabs
          headerColor="regional"
          tabs={[
            {
              tabName: "Approved Exchange Rate",
              tabIcon: Airline,
              clickEvent: (key) => this.selectedTab(key),
              tabContent: (
                <GridItem xs={12} sm={12} md={12}>
                  <ApprovedTable
                    records={ExchangeData}
                    fetchRecords={this.searchExchangeRateApproved}
                    classes={this.props.classes}
                    totalCounts={this.state.totalCountApprove}
                    filterUsers={this.filterUsers}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    user={this.props.user}
                  />
                </GridItem>
              ),
            },
            {
              tabName: "Pending Exchange Rate",
              tabIcon: Seat,
              clickEvent: (key) => this.selectedTab(key),
              tabContent: (
                <GridItem xs={12} sm={12} md={12}>
                  <AllPscTable
                    handleApprove={this.handleApprove}
                    records={pendingExchangeData}
                    fetchRecords={this.searchExchangeRatePending}
                    handleApproveThreshold={this.openApprove}
                    classes={this.props.classes}
                    totalCounts={this.state.totalCountPending}
                    filterUsers={this.filterUsers}
                    currentPage={currentPagePending}
                    pageSize={pageSize}
                    user={this.props.user}
                    handleReject={this.handleReject}
                  />
                </GridItem>
              ),
            },
          ]}
        />

        {/*//Comment Modal*/}
        <Dialog
          fullScreen={fullScreen}
          open={this.state.openComment}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            style={{ backgroundColor: appConstants.REGIONAL_LIGHT_COLOR }}
          >
            <span style={{ color: "white", textTransform: "uppercase" }}>
              Reason for {reason}
            </span>
          </DialogTitle>
          <DialogContent>
            <GridContainer>
              <Grid item md={12} sm={12}>
                <TextField
                  style={{
                    width: "100%",
                    minWidth: "300px",
                  }}
                  // disabled = {disabled}
                  // disabled={disabled}
                  multiline
                  rowsMax="10"
                  id="email"
                  label="Reason"
                  name="comment"
                  value={comment}
                  onChange={this.handleChange}
                  margin="normal"
                  variant="outlined"
                />
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                  }}
                >
                  *State your reason
                </div>
                {/*<span>*/}
                {/*<Button onClick={this.handleActiveInput} color="success" autoFocus>*/}
                {/*Edit*/}
                {/*</Button>*/}
                {/*</span>*/}
              </Grid>
            </GridContainer>
          </DialogContent>
          <DialogActions>
            {isApprove && (
              <Button
                onClick={this.approveExchangeRate}
                color="primary"
                autoFocus
              >
                Submit
              </Button>
            )}
            {isReject && (
              <Button
                onClick={this.rejectExchangeRate}
                color="primary"
                autoFocus
              >
                Submit
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </GridContainer>
    );
  }
}

PscSettingsTable.defaultProps = {
    tableHeaderColor: "gray"
};

PscSettingsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeaderColor: PropTypes.oneOf([
        "warning",
        "primary",
        "regional",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    tableHead: PropTypes.arrayOf(PropTypes.string),
    tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
const mapStatesToProps = state => {
    const { modal, alert, airlines, progress, user, users, requesting} = state;
    return({
            modal, alert, airlines, progress, user, users, requesting
        }
    )
}

export default connect (mapStatesToProps)(withStyles(styles)(PscSettingsTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRate/Index.jsx